import { ChangeDetectionStrategy, Component, ViewEncapsulation, computed, input, model } from '@angular/core';

export const DS_CARD_HEADER_SURFACE_ARRAY = ['lowest', 'low', 'high', 'highest'] as const;
export type DsCardHeaderSurface = (typeof DS_CARD_HEADER_SURFACE_ARRAY)[number];

/**
 * @deprecated Use `DS_CARD_HEADER_SURFACE_ARRAY` instead.
 */
export const DS_CARD_HEADER_VARIANT_ARRAY = ['surface-lowest', 'surface-low', 'surface-high', 'surface-highest'] as const;

/**
 * @deprecated Use `DsCardHeaderSurface` instead.
 */
export type DsCardHeaderVariant = (typeof DS_CARD_HEADER_VARIANT_ARRAY)[number];

@Component({
    selector: 'ds-card-header, button[ds-card-header], a[ds-card-header]',
    templateUrl: './card-header.component.html',
    host: {
        'class': 'ds-card-header',
        '[class]': `hostClass()`,
        '[class.ds-card-header-inverse]': 'inverse()',
    },
    styleUrl: 'card-header.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class DsCardHeader {
    public readonly title = input<string | undefined>('');
    public readonly subtitle = input<string | undefined>('');

    public readonly surface = model<DsCardHeaderSurface>('lowest');
    public readonly inverse = model<boolean>(false);

    /** ------------------ Legacy API ------------------ */
    /** @deprecated Use surface instead */
    public readonly variant = model<DsCardHeaderVariant>('surface-lowest');

    /** ------------------ Computed host class ------------------ */
    // surface: new API wins if explicitly set; legacy used only if new API is default
    protected readonly hostClass = computed(() => {
        const legacy = this.variant();

        const surfaceValue: DsCardHeaderSurface = legacy
            ? legacy === 'surface-lowest'
                ? this.surface()
                : (legacy.replace('surface-', '') as DsCardHeaderSurface)
            : this.surface();

        return `ds-card-header-surface-${surfaceValue}`;
    });
}
